/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Calendar/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import New from './New/index'
import No from './No/index'
import Old from './Old/index'
import React from 'react'
import SentryErrorBoundary from 'DesignSystem/SentryErrorBoundary/react'



/** @type {import('Simple/types.js').View} */
export default function Calendar({
  children,
  viewPath = "/App/Account/Content/Calendar"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let globalFeatureFlagsIsNewCalendarDefaultEnabledValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'feature_flags.is_new_calendar_default_enabled',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: globalFeatureFlagsIsNewCalendarDefaultEnabledValueData,
})
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Old'}>
<Old
  viewPath={`${viewPath}/Old`}
/>
</fromFlow.When>
<SentryErrorBoundary
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<fromFlow.When is={flowValue === 'New'}>
<New
{...childProps}
  viewPath={`${viewPath}/New`}
/>
</fromFlow.When>
)}
</SentryErrorBoundary>
{children}
</React.Fragment>)
}